export const API_URL = process.env.VUE_APP_BACKEND_URL;
export const FRONTEND_URL = process.env.VUE_APP_FRONTEND_URL;
export const TRIAL_FRONTEND_URL = process.env.VUE_APP_TRIAL_FRONTEND_URL;
export const MYTRIAL_URL = process.env.VUE_APP_MYTRIAL_URL;
export const FREE_TRIAL = 'https://www.samsungsds.com/kr/trial/trial.html';
export const DT_ASSESSMENT_PAGE = 'https://www.samsungsds.com/kr/digital-transformation-assessment/dta.html#Enterprise_DTA';
export const SURVEY_ID_SRM = process.env.VUE_APP_SURVEY_ID_SRM;
export default API_URL;
